// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"379fc0a4","220":"734dd961","501":"a718643e","586":"3435494e","716":"de7bbd11","923":"6489de68"}[chunkId] + ".chunk.js";
};